import {
    displayShortDateOrNA,
    displayPercentOrNA
} from '../../utils/Format/Format';

export const riskAllocationUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        mutualFund: { ticker, riskAllocationRankings = [] }
    } = gqlResult;

    const displayInfotip = ticker === 'TMSRX' || ticker === 'TMSSX';
    const setDefinitionByName = (name) => {
        const infotip =
            {
                'Equity Research Long/Short':
                    'Relies on fundamental research to provide long and short exposure to global large-cap stocks. Long positions are established in companies the adviser views as most attractive and short positions are established in companies viewed as least attractive.',
                'Macro and Absolute Return':
                    'Seeks to leverage global research expertise to select investments that we believe represent the best investment ideas across all equity and fixed income asset classes.',
                'Style Premia':
                    'Selects the various instruments across asset classes that include currencies, equity index, futures, and bond or interest rate futures based on whether the instruments exhibits positive characteristics or factors.',
                'Volatility Relative Value':
                    'Primarily uses equity index call and put options to take advantage of the relative attractiveness of the volatility premium.',
                'Fixed Income Absolute Return':
                    'Seeks consistent positive returns without constraints to particular benchmarks or fixed income asset classes.',
                'Quantitative Equity Long/Short':
                    'Relies on quantitative research capabilities to provide long and short exposure to small- and mid-cap U.S. stocks.'
            }[name] || '';

        return infotip;
    };

    let returnData = [...riskAllocationRankings]
        .sort((a, b) => b.percentTotalNetAssets - a.percentTotalNetAssets)
        .map((d) => ({
            label: d.name,
            values: [{ val: displayPercentOrNA(d.percentTotalNetAssets) }]
        }));

    if (displayInfotip) {
        returnData = [...riskAllocationRankings]
            .sort((a, b) => b.percentTotalNetAssets - a.percentTotalNetAssets)
            .map(
                (d) =>
                    d.name === 'Other'
                        ? {
                              label: d.name,
                              values: [
                                  {
                                      val: displayPercentOrNA(
                                          d.percentTotalNetAssets
                                      )
                                  }
                              ]
                          }
                        : {
                              label: d.name,
                              values: [
                                  {
                                      val: displayPercentOrNA(
                                          d.percentTotalNetAssets
                                      )
                                  }
                              ],
                              showDefinition: false,
                              definition: setDefinitionByName(d.name)
                          }
            );
    }

    const asOf =
        riskAllocationRankings[0] && riskAllocationRankings[0].asOfDate;

    const asOfDate = displayShortDateOrNA(asOf);

    return {
        headers: ['Component Strategy', 'Contribution to Risk'],
        asOfDate,
        data: returnData
    };
};
